import { render } from "./FavouriteMessages.vue?vue&type=template&id=5c8e8833"
import script from "./FavouriteMessages.vue?vue&type=script&lang=js"
export * from "./FavouriteMessages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__